/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

import React from 'react';

import LocaleToggle from 'containers/LocaleToggle';
// import langIcon from 'aurora-images/langicon.svg';

function SelectLanguage(props) {
  // eslint-disable-next-line react/prop-types
  const { type } = props;
  return (
    <div>
      {/* <img src={langIcon} alt='help' /> */}
      <LocaleToggle type={type} />
    </div>
  );
}

export default SelectLanguage;
